import { NgClass } from "@angular/common";
import { AfterContentInit, Component, ContentChildren, QueryList } from "@angular/core";
import { CorpTabComponent } from "../tab/corp-tab.component";

@Component({
    selector: 'corp-tab-group',
    standalone: true,
    imports: [NgClass],
    templateUrl: './corp-tab-group.component.html'
  })
  export class CorpTabGroupComponent implements AfterContentInit {

    @ContentChildren(CorpTabComponent) corpTabList: QueryList<CorpTabComponent> | null = null;

    // contentChildren are set
    ngAfterContentInit() {
      // get all active tabs
      let activeTab = this.corpTabList?.filter((tab)=>tab.active);

      // if there is no active tab set, activate the first
      if(activeTab==undefined || activeTab.length === 0) {
        this.selectTab(this.corpTabList?.first);
      }
    }

    selectTab(tab: any){
      // deactivate all tabs
      this.corpTabList?.toArray().forEach(tab => tab.active = false);

      // activate the tab the user has clicked on.
      tab.active = true;
    }
  }